import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/information/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/information/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/information/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/information/updateById', data)
}
export function updateStatus (data) {
  return request.post('/business/information/updateStatus', data)
}
// 删除
export function deleteById (id) {
  return request.get(`/business/information/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/information/delete/batch', {
    params: {
      ids
    }
  })
}
